<div class="flex flex-col gap-12">
  <app-back-button text="{{ 'page.tags.title' | translate }}" link="/panel/tags/list"></app-back-button>

  <div class="flex items-center justify-between">
    <app-title>{{ 'page.tag-detail.title' | translate:{ name : (tag$ | async)?.name } }}</app-title>

    <ng-container *ngIf="tag$ | async as tag">
      <div class="flex items-center gap-2">
        <app-button text="{{ 'action.edit' | translate }}" variant="plain" icon="/assets/images/icon-pencil.svg" (click)="editTag()"></app-button>
        <app-button text="{{ 'action.delete' | translate }}" variant="danger" icon="/assets/images/icon-trash.svg" (click)="deleteTag()"></app-button>
      </div>
    </ng-container>
  </div>

  <app-tabs>
    <app-tab text="{{ 'page.tag-detail.tab.info' | translate }}" link="info"></app-tab>
  </app-tabs>

  <div>
    <router-outlet></router-outlet>
  </div>
</div>
